import { normalizeUrl } from '../../utils/url';
function calculateIsINPeventDuringNavigation(inpStartTime, navigationParams) {
    if (!navigationParams) {
        return undefined;
    }
    if (navigationParams.isDuringNavigation) {
        return true;
    }
    if (!navigationParams.lastNavigationTimings) {
        return undefined;
    }
    const { start: navigationStart, end: navigationEnd } = navigationParams.lastNavigationTimings;
    return navigationStart && navigationEnd
        ? inpStartTime >= navigationStart && inpStartTime <= navigationEnd
        : undefined;
}
const getEventTarget = (metric) => {
    let target = metric.attribution.eventEntry?.target;
    /**
     * There is a bug in Chrome due to which it sometimes would not report target for some events:
     * https://bugs.chromium.org/p/chromium/issues/detail?id=1367329
     * This is handled in web-vitals library by trying to find the target from the entries and exposing it's selector:
     * https://github.com/GoogleChrome/web-vitals/pull/421
     * While selector is exposed, the target itself is not, so we need to find it from the entries, similarly to what they do in the extension:
     * https://github.com/GoogleChrome/web-vitals-extension/pull/168/files#diff-a828877823604a91a1a9b7d31dc0c83c85d70e627780a93cf2934e0cc1dbe053
     */
    if (!target && metric.attribution.eventTarget) {
        target = metric.entries.find((entry) => entry.target)?.target;
    }
    return target;
};
export const toInpMetric = (metric, getHtmlElementMetadata) => {
    const { value, attribution } = metric;
    const htmlElementMetadata = getHtmlElementMetadata(getEventTarget(metric) || null);
    // Retrieve loAF related to this INP only
    const inpStartTime = attribution.eventEntry?.startTime || 0;
    const inpEndTime = (attribution.eventEntry?.startTime || 0) +
        (attribution.eventEntry?.duration || 0);
    const loafs = performance
        .getEntriesByType('long-animation-frame')
        .filter(({ startTime: loafStartTime, duration }) => {
        const loafEndTime = loafStartTime + duration;
        return loafEndTime >= inpStartTime && loafStartTime <= inpEndTime;
    });
    const navigationParams = htmlElementMetadata.navigationParams;
    const inpIsDuringNavigation = calculateIsINPeventDuringNavigation(inpStartTime, navigationParams);
    return {
        inpValue: Math.trunc(value),
        inpUrl: normalizeUrl(window.location.href),
        inpRating: metric.rating,
        inpEventType: attribution.eventType,
        inpTargetSelector: attribution.eventTarget,
        inpStartTime: attribution.eventTime
            ? Math.trunc(attribution.eventTime)
            : undefined,
        inpProcessingStart: attribution.eventEntry?.processingStart
            ? Math.trunc(attribution.eventEntry.processingStart)
            : undefined,
        inpProcessingEnd: attribution.eventEntry?.processingEnd
            ? Math.trunc(attribution.eventEntry.processingEnd)
            : undefined,
        inpInteractionId: attribution.eventEntry?.interactionId,
        inpLoadState: attribution.loadState,
        ...(htmlElementMetadata.compType && {
            inpComponentType: htmlElementMetadata.compType,
        }),
        ...(htmlElementMetadata.widgetId && {
            inpWidgetId: htmlElementMetadata.widgetId,
        }),
        ...(htmlElementMetadata.applicationId && {
            inpApplicationId: htmlElementMetadata.applicationId,
        }),
        ...(loafs.length > 0 && { metadata: { loafs } }),
        inpIsDuringNavigation,
    };
};
//# sourceMappingURL=inp.js.map